<app-section-wrapper-container>
	<form
		class="um-section-parent-container"
		[formGroup]="detailsForm"
		(keypress)="onKeyPress($event)">
		<div>
			<app-input-field
				formControlName="purchaseListPrice"
				[isNumber]="true"
				[label]="
					'vehicles|record|purchase-details-section|field-label|purchase-list-price'
				" />
			<app-input-field
				formControlName="purchasePaidPrice"
				[isNumber]="true"
				[label]="
					'vehicles|record|purchase-details-section|field-label|purchase-paid-price'
				" />
		</div>
		<div>
			<app-datetime-picker
				formControlName="purchasedAt"
				[label]="
					'vehicles|record|purchase-details-section|field-label|purchased-at'
				"
				[showTime]="false"
				[excludeFutureDates]="true" />
		</div>
	</form>
</app-section-wrapper-container>
